import { motion } from 'framer-motion';
import { ANIMATION_DURATION_MS } from '@/lib/kiosk-flow';

const duration = ANIMATION_DURATION_MS / 1000;

interface Props {
  stepKey: string;
  direction: number;
  children: React.ReactNode;
}

export function KioskStepWrapper({ stepKey, direction, children }: Props) {
  const variants = {
    enter: { x: direction * 60, opacity: 0 },
    center: { x: 0, opacity: 1 },
    exit: { x: direction * -60, opacity: 0 },
  };

  return (
    <motion.div
      key={stepKey}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{ duration, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
}
